import { render, staticRenderFns } from "./PanelCourseList.vue?vue&type=template&id=27a08110&scoped=true"
import script from "./PanelCourseList.vue?vue&type=script&lang=js"
export * from "./PanelCourseList.vue?vue&type=script&lang=js"
import style0 from "./PanelCourseList.vue?vue&type=style&index=0&id=27a08110&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a08110",
  null
  
)

export default component.exports